(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dfw-search-entry"] && !Shopify.designMode) return;
  try {
    class DfwSearchEntry extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      Promise.all([
        customElements.whenDefined('dialog-component'),
        customElements.whenDefined('predictive-search-component')
      ]).then(() => {
        if (!this.isConnected) return;
        const modal = document.getElementById('search-modal');
        const trigger = this.querySelector('[data-search-trigger]');
        const fallback = this.querySelector('[data-search-fallback]');
        if (!modal || typeof modal.showDialog !== 'function' || !trigger || !fallback) return;
        if (fallback.contains(document.activeElement) || fallback.querySelector('[name=q]')?.value) return;
        trigger.addEventListener('click', () => modal.showDialog());
        fallback.hidden = true;
        trigger.hidden = false;
      });
    }
  }
  if (!customElements.get('dfw-search-entry')) customElements.define('dfw-search-entry', DfwSearchEntry);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dfw-shop-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const key = 'dfw-shop-return-v1';
  const productPath = (url) => url.pathname.match(/\/products\/([^/]+)/)?.[1];
  const restore = () => {
    const root = document.querySelector('[data-shop-navigation]');
    const link = root?.querySelector('[data-shop-return]');
    if (!link) return;
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (!saved || saved.product !== productPath(new URL(location.href)) || Date.now() - saved.time > 7200000) return;
      const url = new URL(saved.url, location.origin);
      if (url.origin !== location.origin || !/\/(collections\/|pages\/|search(?:\/|$))/.test(url.pathname)) return;
      link.href = url.pathname + url.search;
      link.querySelector('[data-shop-return-label]').textContent = root.dataset.backLabel;
    } catch {}
  };
  document.addEventListener('click', (event) => {
    const root = document.querySelector('[data-shop-navigation]');
    if (!root || !['collection', 'search', 'page'].includes(root.dataset.page)) return;
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    const url = new URL(anchor.href, location.origin);
    if (url.origin !== location.origin || !productPath(url)) return;
    try { sessionStorage.setItem(key, JSON.stringify({product:productPath(url),url:location.pathname + location.search,time:Date.now()})); } catch {}
  }, true);
  restore();
  document.addEventListener('DOMContentLoaded', restore);
  window.addEventListener('pageshow', restore);
})();
  } catch(e) { console.error(e); }
})();

})();
